/**
 * Contato da igreja para pedidos sobre dados pessoais (LGPD).
 * Preenchido pelo administrador na tela "Igreja" e exibido no aviso do elo Visitantes.
 * Telefone é guardado só com dígitos (10 ou 11, com DDD).
 */

export interface ContatoIgreja {
  email: string | null;
  telefone: string | null;
}

export function soDigitosContato(valor: string): string {
  return valor.replace(/\D/g, "").slice(0, 11);
}

export function formatarTelefoneContato(digitos: string): string {
  const d = soDigitosContato(digitos);
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return d;
}

export function emailContatoValido(email: string): boolean {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim());
}

export function telefoneContatoValido(digitos: string): boolean {
  return /^[0-9]{10,11}$/.test(digitos);
}

/** Texto do contato usado nos avisos: "pelo e-mail x ou pelo telefone y" ou "falando com a liderança". */
export function textoContatoIgreja(contato: Partial<ContatoIgreja> | null | undefined): string {
  const email = contato?.email?.trim();
  const tel = contato?.telefone ? formatarTelefoneContato(contato.telefone) : "";
  if (email && tel) return `pelo e-mail ${email} ou pelo telefone ${tel}`;
  if (email) return `pelo e-mail ${email}`;
  if (tel) return `pelo telefone ${tel}`;
  return "falando com a liderança da igreja";
}
